import { useCallback } from 'react';

import { useProductCenterApi } from 'api/ApplicationApi';
import { FileRemoveButton } from 'library/components/controls/files/FileRemoveButton';

export type HealthCheckFileRemoveButtonProps = {
	unitId: number;
	fileId: number;
	onDeleted?: () => void | Promise<void>;
	disabled?: boolean;
};

export const HealthCheckFileRemoveButton = ({
	unitId,
	fileId,
	onDeleted,
	disabled,
}: HealthCheckFileRemoveButtonProps): React.JSX.Element => {
	const { api } = useProductCenterApi();

	const deleteHealthCheckFile = api.deleteHealthCheckFile as (
		unitId: number,
		fileId: number
	) => Promise<unknown>;

	const deleteFn = useCallback(
		() => deleteHealthCheckFile(unitId, fileId),
		[deleteHealthCheckFile, fileId, unitId]
	);

	return (
		<FileRemoveButton
			deleteFn={deleteFn}
			onDeleted={onDeleted}
			disabled={disabled}
		/>
	);
};
